// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../../../fragments/commonFragments.generated';
export type ProductOptionCard_CheckoutConfigOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, cutoffDate?: Types.Scalars['Date']['input'] | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, marketingDescription?: string | null | undefined, displayPackageOptionsAsSingleProduct?: boolean | null | undefined, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, marketingName: string } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, isSelected: boolean, totalPriceInCents: number, totalCostInCents: number, canBeSelected: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, wouldDeselect: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }>, primaryProduct?: { __typename?: 'MaterialVariant', id: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, option: { __typename?: 'ReadyPlanOption', id: string, name: string, description?: string | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, marketingDescription?: string | null | undefined }, optionImage?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, materialVariant?: { __typename?: 'MaterialVariant', id: string, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } } | null | undefined } }> };

export type ProductOptionCard_CheckoutConfigPotentialOptionFragment = { __typename?: 'CheckoutConfigPotentialOption', id: string, isSelected: boolean, totalPriceInCents: number, totalCostInCents: number, canBeSelected: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, wouldDeselect: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }>, primaryProduct?: { __typename?: 'MaterialVariant', id: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, option: { __typename?: 'ReadyPlanOption', id: string, name: string, description?: string | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, marketingDescription?: string | null | undefined }, optionImage?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, materialVariant?: { __typename?: 'MaterialVariant', id: string, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } } | null | undefined } };

export const ProductOptionCard_CheckoutConfigPotentialOptionFragmentDoc = gql`
    fragment ProductOptionCard_CheckoutConfigPotentialOption on CheckoutConfigPotentialOption {
  id
  isSelected
  totalPriceInCents
  totalCostInCents
  canBeSelected {
    allowed
    disabledReasons {
      message
    }
  }
  wouldDeselect {
    ...Named
  }
  primaryProduct {
    id
    featuredImage {
      id
      asset {
        id
        previewUrl(resizing: {width: 192, region: SQUARE})
      }
    }
  }
  option {
    id
    name
    description
    globalOption {
      id
      marketingDescription
    }
    optionImage {
      id
      previewUrl(resizing: {width: 192, region: SQUARE})
    }
    materialVariant {
      id
      listing {
        id
        description
        brand {
          id
          name
        }
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export const ProductOptionCard_CheckoutConfigOptionGroupFragmentDoc = gql`
    fragment ProductOptionCard_CheckoutConfigOptionGroup on CheckoutConfigOptionGroup {
  id
  cutoffDate
  group {
    id
    marketingDescription
    displayPackageOptionsAsSingleProduct
    personalizationType {
      code
    }
    readyPlanLocation {
      id
      marketingName
    }
  }
  options {
    ...ProductOptionCard_CheckoutConfigPotentialOption
  }
}
    ${ProductOptionCard_CheckoutConfigPotentialOptionFragmentDoc}`;